import { CartErrorTypeEnum } from '@sola/schema/dotcom/cart/errors.js';

import { useDonate } from '../donate-context';
import { DonateErrorObject } from '../donate.types';

export type DonateErrorValue = `${CartErrorTypeEnum}`;

const isValidCartErrorValue = (value: string): value is DonateErrorValue => {
  return Object.values(CartErrorTypeEnum).includes(value as CartErrorTypeEnum);
};

export const useDonateErrors = () => {
  const { config } = useDonate();

  const getErrorObject = (
    messageType: DonateErrorValue,
    payload: { [key: string]: string | number } = {},
  ): DonateErrorObject => {
    const titleKey = `checkout.errors.${messageType}.title`;
    const messageKey = `checkout.errors.${messageType}.message`;

    return {
      title: {
        key: titleKey,
        payload,
      },
      message: {
        key: messageKey,
        payload,
      },
    };
  };

  // TODO: This is too fragile and I don't think is really necessary.
  // Child bio has a BioError component that could probably be refactored for re-use (it's based on checkout's GlobalError component).
  const translateDonateError = (
    messageType: DonateErrorValue,
  ): DonateErrorObject => {
    switch (messageType) {
      case 'ITEM_MAX':
      case 'CART_MAX':
        return getErrorObject(messageType, {
          maxLimit: config.donationLimits.max,
        });
      case 'ITEM_MIN':
        return getErrorObject(messageType, {
          minLimit: config.donationLimits.min,
        });
      default:
        return {
          message: {
            key: 'checkout.errors.GENERIC_FUND.message',
            payload: {},
          },
        };
    }
  };

  const getDonateErrorMessage = (errorType: string): DonateErrorObject => {
    if (isValidCartErrorValue(errorType)) {
      return translateDonateError(errorType);
    }

    return {
      message: {
        key: 'checkout.errors.GENERIC_FUND.message',
        payload: {},
      },
    };
  };

  return {
    translateDonateError,
    getDonateErrorMessage,
  };
};
